function VarOptionModel({ id, option }) {
  let obj = {};
  obj.id = id;
  obj.option = option;
  return obj;
}

export default VarOptionModel;
